import React, { Component } from 'react';
import { TabContent } from 'reactstrap';

export class TabContentV2 extends Component {
  render() {
    const { activeTab, ...other } = this.props;

    return <TabContent activeTab={activeTab} {...other} />;
  }
}

export default TabContentV2;
